import i18next from 'i18next';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import React from 'react';

import ButtonLoading from '~app/components/ButtonLoading';
import { field } from '~propTypes/field';
import Error from '~app/components/Error';
import { hasBeenSubmitted, hasErrorsAndIsTouched } from '~utils/formik';
import { useKind } from '~app/hooks/useKind';
import { IDENTITY_BANNERS } from '~constants/banners';
import Banner from '~app/components/Banner';
import BirthFields from '~app/components/BirthInformation/BirthForm/BirthFields';
import LaborFields from '~app/components/LaborInformation/LaborForm/LaborFields';
import Select from '~app/components/Select';

import { getWhenBuyOptions } from '../whenBuy';

import { BirthHeader, LaborHeader, WhenBuyHeader } from './headers';
import styles from './styles.module.scss';

const SocioeconomicForm = ({
  values,
  onChange,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  setLaborSituation,
  buttonLoading,
  additionalFields,
  submitCount
}) => {
  const kind = useKind();
  const whenBuyOptions = getWhenBuyOptions();

  return (
    <div className={styles.formContainer}>
      <Banner src={IDENTITY_BANNERS[kind]} />
      <div className={styles.container}>
        <div className={styles.unifiedCard}>
          <BirthFields
            values={values}
            onChange={onChange}
            errors={errors}
            setFieldTouched={setFieldTouched}
            touched={touched}
            setFieldValue={setFieldValue}
            header={BirthHeader}
            additionalFields={additionalFields}
            formClassName={styles.formFieldsContainer}
          />
          <div className={styles.sectionDivider} />
          <LaborFields
            values={values}
            onChange={onChange}
            errors={errors}
            setFieldTouched={setFieldTouched}
            touched={touched}
            setFieldValue={setFieldValue}
            setLaborSituation={setLaborSituation}
            header={LaborHeader}
            additionalFields={additionalFields}
            formClassName={styles.formFieldsContainer}
          />
          {values.laborSituation && (
            <span className={styles.laborMessage}>
              <b>{i18next.t(`LaborInformationMessageTitle:${values.laborSituation}`)}</b>
              {i18next.t(`LaborInformationMessage:${values.laborSituation}`)}
            </span>
          )}
          <div className={styles.sectionDivider} />
          <div className={styles.whenBuyField}>
            <WhenBuyHeader />
            <div className="section-label">{i18next.t('CreditSimulation:whenBuyLabel')}</div>
            <Select
              name="when_buy"
              options={whenBuyOptions}
              placeholder={i18next.t('Common:selectPlaceholder')}
              value={whenBuyOptions.find(option => option.value === values.whenBuy)}
              error={touched.whenBuy && errors.whenBuy}
              onChange={option => setFieldValue('whenBuy', option.value)}
              onBlur={() => setFieldTouched('whenBuy', true, true)}
            />
          </div>
        </div>
        <div className={styles.messageContainer}>
          <Error
            error={i18next.t('SocioeconomicInformation:hasErrors')}
            show={hasBeenSubmitted(submitCount) && hasErrorsAndIsTouched(errors, touched)}
            errorClassName={styles.errorMessage}
          />
          <ButtonLoading type="submit" primary loading={buttonLoading}>
            {i18next.t('SocioeconomicInformation:button')}
          </ButtonLoading>
        </div>
      </div>
    </div>
  );
};

SocioeconomicForm.propTypes = {
  additionalFields: arrayOf(field),
  buttonLoading: bool,
  errors: shape({}),
  setFieldTouched: func,
  setFieldValue: func,
  setLaborSituation: func,
  submitCount: number,
  touched: shape({}),
  values: shape({
    gender: string,
    birthday: string,
    nationality: string,
    laborSituation: string,
    emittedInvoicesLastYear: string,
    monthlyIncomes: string,
    jobStartDate: string,
    whenBuy: string
  }),
  onChange: func
};

export default SocioeconomicForm;
